import React from 'react';
const Spinner = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    className="spinner"
    style={{ background: '0% 0%' }}
  >
    <circle
      cx="50"
      cy="50"
      strokeLinecap="round"
      r="40"
      strokeDasharray="62.83185307179586 62.83185307179586"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        calcMode="linear"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
        dur="1.5s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
    <style>
      {`
        .spinner {
          height: 100%;
        }
        .spinner circle {
          fill: none;
          stroke: currentcolor;
          stroke-width: 8px;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 10;
        }
      `}
    </style>
  </svg>
);

export default Spinner;
